import React, { useContext, useEffect, useState } from 'react';
import PageTitle from "../../Components/PageTitle";
import { useLocation } from 'react-router-dom'
import Select from 'react-select';
import axios from 'axios';
import Swal from "sweetalert2";
import { ConfigContext } from '../../Context/ConfigContext';
import { NoRecords } from '../../Components/Shimmer';
import { abstartOldUrl, checkPDFLink, currentDateAndTime, decodeData, formatDateAndTime, formatDateWithTime, } from '../../Constants/constants'
import { formatDate, formatMonthYear, IconButton, SubmitButton } from '../../Components/InputElements';
import FileNotFound from '../../Components/FileNotFound';


function MyPolicy(props) {
    const { apiURL, apiHeaderJSON, permissions } = useContext(ConfigContext);
    const locationParam = useLocation();
    const queryParams = new URLSearchParams(locationParam.search);
    const encodedData = queryParams.get("abs");
    const decodedData = decodeData(encodedData, permissions);
    const [loading, setLoading] = useState(false);
    const [postLoading, setPostLoading] = useState(false);
    const [policyModal, setPolicyModal] = useState(false);
    const [limitAction, setLimitAction] = useState(false);
    const limitOptions = [10, 25, 50, 100, 200, 500];
    const [formData, setFormData] = useState({
        company_policy_id:"",
        checkedPolicy:"",
        remarks:"",
        company_policy_title: "",
        company_policy_document_url: "",
        company_policy_content_type: "",
        company_policy_content: "",
        company_policy_status: "",
});
    const [isChanged, setIsChanged] = useState(false);
    const [rows, setRows] = useState([]);
    const [pagination, setPagination] = useState({
        next: false,
        prev: false,
        page: 1,
        total_records: "",
        total_pages: "",
        limit: 10,
    });

    function getList() {
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Home/GetPolicies`, {
            params:{
                limit: pagination?.limit,
                page: pagination?.page,
            } ,headers,})
            .then((response) => {
                const { success, data, total_records, total_pages, next, prev, page } = response?.data;
                // console.log("GetPolicies ==>", response);
                if (success === true) {
                    setRows(data);
                    setPagination({
                    ...pagination,
                    next,
                    prev,
                    page,
                    total_records,
                    total_pages,
                });
                }else{
                    setRows([]);
                    setPagination({
                    ...pagination,
                    next: false,
                    prev: false,
                    page: 1,
                    total_records: "",
                    total_pages: "",
                    limit: 10,
                    });
                }
                setLoading(false);
            })
            .catch((error)=>{
                console.error(error);
                setLoading(false);
                Swal.fire({
                    title: `<strong>Failed}</strong>`,
                    text: "Opps...! Something went wrong. Unbale to get policy list.",
                    icon: "error",
                    showConfirmButton: true,
                    allowOutsideClick: false,
                });
            });
    }


    const handleSubmit = () => {
        const headers = apiHeaderJSON;

        Swal.fire({
        title: 'Are you sure?',
        text: `Do you want to agree the Terms & Conditions?`,
        icon: 'warning',
        // reverseButtons: true,
        input: 'text',
        inputPlaceholder: 'Remark',
        showCancelButton: true,
        confirmButtonText: 'Yes, I Agree!',
        cancelButtonText: `No! Not Now`,
        }).then((result) => {
            if (result.isConfirmed) {
            const data = {
                company_policy_id: formData?.company_policy_id, 
                remarks: result?.value || "",
                date: currentDateAndTime(),
            };
            setPostLoading(true);
            console.log("data ====>>>", data);
            axios
            .post(`${apiURL}Home/ReviewPolicy`, data, { headers })
            .then((response) => {
                const { success } = response.data;
                if (success === true) {
                    setFormData({
                        ...formData,
                        company_policy_id:"",
                        checkedPolicy:"",
                        remarks:"",
                        company_policy_title: "",
                        company_policy_document_url: "",
                        company_policy_content_type: "",
                        company_policy_content: "",
                        company_policy_status: "",
                    });
                    setPolicyModal(false);
                    getList();

                } else {
                    
                }
                setPostLoading(false);
                Swal.fire({
                title: `<strong>${
                    response.data.success === true ? "Success" : "Failed"
                }</strong>`,
                text: response.data.message,
                icon: response.data.success === true ? "success" : "error",
                showConfirmButton: true,
                allowOutsideClick: false,
                });
            })
            .catch((error)=>{
                setPostLoading(false);
                Swal.fire({
                    title: `<strong>Failed}</strong>`,
                    text: "Opps...! Something went wrong.",
                    icon: "error",
                    showConfirmButton: true,
                    allowOutsideClick: false,
                });
            });
        }})
      };
      const getView=(row)=>{
        setFormData({
            ...formData,
            company_policy_id: row?.company_policy_id,
            company_policy_title: row?.company_policy_title,
            company_policy_id: row?.company_policy_id,
            company_policy_document_url: row?.company_policy_document_url,
            company_policy_content_type: row?.company_policy_content_type,
            company_policy_content: row?.company_policy_content,
            company_policy_status: row?.company_policy_status,
        });
        setPolicyModal(true);
      }

    useEffect(() => {
        // getPayslip();
        setLoading(true);
        getList();
    }, []);

    useEffect(() => {
        if(isChanged){
            getList();
            setIsChanged(false);
        }
    }, [isChanged]);

    function handleClearAll() {
        setFormData({
            ...formData,
            company_policy_id:"",
            checkedPolicy:"",
            remarks:"",
            company_policy_title: "",
            company_policy_document_url: "",
            company_policy_content_type: "",
            company_policy_content: "",
            company_policy_status: "",
        });
    }

    useEffect(() => {
        if (limitAction) {
            getList();
            setLimitAction(false);
        }
    }, [limitAction]);

    const handleLimitChange = (e) => {
        // console.log(e.target.value);
        setPagination(
            {
                ...pagination,
                limit: e.target.value,
                page: 1,
            });
        setLimitAction(true);
    };
    const handleChanged = (type) => {
        setPagination({
          ...pagination,
          page: parseInt(type.target.value),
        });
        setLimitAction(true);
    }
    const handlePrev = () => {
        // console.log(pagination?.prev)
        if (pagination?.prev === true) {
            console.log(pagination?.page - 1)
            setPagination({
                ...pagination,
                page: pagination?.page - 1,
            });
        }
        setLimitAction(true);
    }
    const handleNext = () => {
        // console.log(pagination?.next)
        if (pagination?.next === true) {
            // console.log(pagination?.page + 1)
            setPagination({
                ...pagination,
                page: pagination?.page + 1,
            });
        }
        setLimitAction(true);
    }


    return (
        <>
            {!loading ?
                <div class="main-content" >
                    <div class="page-content">
                        <div className="container-fluid">
                            <br />
                            <PageTitle title={`My policy`} primary={`My Details`} />
                            <div className="card">
                                <div className="card-body">
                                    <div className='card'>
                                        <div>
                                            <div style={{ "maxHeight": "65vh", "overflowY": "auto" }}>
                                                <table className={`table table-borderless table-hover align-middle mb-0 table-bordered table-stripped position-relative`}>
                                                    <thead className='bg-primary text-light bg-gradient  sticky-top z-1'>
                                                        <tr>
                                                            <th style={{ width:"5%"}} className=' text-center'>Sr.No.</th>
                                                            <th style={{ width:"10%"}} className=' text-center noWrap'>Published Date</th>
                                                            <th style={{ width:"10%"}} className=' text-center noWrap'>Reviewed Date</th>
                                                            <th className='noWrap'>Policy Title</th>
                                                            <th style={{ width:"10%"}} className=' text-center'>Status</th>
                                                            <th className=' text-center'>Remark</th>
                                                            <th style={{ width:"7%"}} className=' text-center'>Action</th>
                                                        </tr>
                                                    </thead>
                                                    {rows?.length === 0 ?
                                                        <tbody>
                                                            <tr>
                                                                <td colSpan={6}>
                                                                    <NoRecords />
                                                                </td>
                                                            </tr>
                                                        </tbody> :
                                                        <tbody>
                                                            {
                                                                rows?.map((row,idx) => {
                                                                    return <tr key={row.employee_policy_review_id}>
                                                                        <td className=' text-center'>{idx+1}</td>
                                                                        <td className=' text-center'>{row.policy_assign_date? formatDate(row?.policy_assign_date) : "--"}</td>
                                                                        <td className=' text-center'>{row.reviewed_date? formatDate(row?.reviewed_date) : "--"}</td>
                                                                        <td>{row.company_policy_title || "--"}</td>
                                                                        <td>{row?.company_policy_status ? 
                                                                            <div style={{ fontSize: "0.65rem" }} className={` bg-${row?.PolicyStatusClasses} fw-semibold px-1 text-center py-1 text-white rounded-4`}>
                                                                                {row?.company_policy_status}
                                                                            </div> : "--"
                                                                            }
                                                                        </td>
                                                                        <td className={`${row?.company_policy_remarks?.length >= 30 ? "textEllipse" : "noWrap"}`}>{row.company_policy_remarks || '--'}</td>
                                                                        <td className=" text-center">
                                                                            <div className="d-flex justify-content-around gap-2">
                                                                            {row?.company_policy_status!=="Published"?
                                                                                decodedData?.includes(1) && (
                                                                                <IconButton 
                                                                                    onClick={() => {
                                                                                        getView(row);
                                                                                    }} type='success' icon='ri-file-info-line' tooltipName='View' tooltipPosition='bottom' />
                                                                                ) : 
                                                                                ("")
                                                                            }
                                                                            {row?.company_policy_status==="Published"?
                                                                                decodedData?.includes(3) && (
                                                                                <IconButton 
                                                                                onClick={() => {
                                                                                    getView(row);
                                                                                }} type='primary' icon='ri-article-line' tooltipName='Acknowledge' tooltipPosition='bottom' />
                                                                                ) : 
                                                                                ("")
                                                                            }
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                })
                                                            }
                                                        </tbody>
                                                    }
                            
                                                </table>
                                            </div>
                                            <div className="d-flex bg-light justify-content-between flex-wrap align-items-center w-100 py-2 px-2 flex-wrap">
                                                <button disabled={ !pagination?.prev } type="button" onClick={() => handlePrev()} className={`btn btn-warning btn-label waves-effect waves-light`}>
                                                    <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                                                    Previous
                                                </button>
                                                <button disabled={ !pagination?.next} type="button" onClick={() => handleNext()}
                                                className={`d-md-none d-block btn btn-primary btn-label waves-effect right waves-light`}>
                                                <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                                                Next
                                                </button>
                                                <div className="col-md-4" style={{ display: "flex", alignItems: "center" }}>
                                                {<small>
                                                    Total Records: {pagination?.total_records} | Total
                                                    Pages: {pagination?.total_pages} | Current Page:
                                                    {pagination?.page}
                                                    </small>
                                                }
                                                </div>
                                                <div className="col-md-2">
                                                <select className="form-select" onChange={(e) => handleChanged(e)}>
                                                    {Array.from( { length: pagination?.total_pages }, (_, i) => (
                                                        <option selected={pagination?.page === i + 1} key={i} value={i + 1} >
                                                        Page {i + 1}
                                                        </option>
                                                    )
                                                    )}
                                                </select>
                                                </div>
                                                <div className="col-md-2">
                                                <select className="form-select" onChange={(e) => handleLimitChange(e)} value={pagination?.limit}>
                                                    {pagination?.total_records >= 1 && (
                                                    <option value={pagination?.total_records}>
                                                        All
                                                    </option>
                                                    )}
                                                    {limitOptions?.map((option) => (
                                                    <option key={option} value={option}>
                                                        Limit {option}
                                                    </option>
                                                    ))}
                                                </select>
                                                </div>
                                                <button disabled={ !pagination?.next} type="button" onClick={() => handleNext()}
                                                className={`d-md-block d-none btn btn-primary btn-label waves-effect right waves-light`}>
                                                <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                                                Next
                                                </button>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {policyModal && (
                                <div className="modal show" tabIndex={-1}
                                    style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)",}}
                                    aria-labelledby="myModalLabel"
                                    aria-hidden="true">
                                    <div className="m-auto mt-4 w-modal">
                                        <div className="modal-content">
                                            <div className="modal-header pb-0">
                                                <h5 className="modal-title">{formData?.company_policy_status==="Published" ? "Acknowledge Policy":`Policy: ${formData?.company_policy_title || 'No Title'}`}</h5>
                                                <button type="button" disabled={postLoading} onClick={()=>{ if(!postLoading){ setPolicyModal(false); handleClearAll(); } }}
                                                className="btn-close" aria-label="Close"/>
                                            </div>
                                            <div className="modal-body p-0">
                                                <div id='policy' className={`policy-container p-2`} >
                                                    {/* <h3 className="text-center ellipse_heading">{formData?.company_policy_title}</h3> */}
                                                        {/* <div className=''> */}
                                                            <div className={`${formData?.company_policy_status==="Published"? "mb-1": "mb-4"}  m-auto bg-white policyAcceptBox p-md-3 p-0 mx-0 overflow-hidden rounded-2 grayBlurShadow`}>
                                                                <div className={`m-auto rounded-3 overflow-hidden ${formData?.company_policy_content_type === "1" ? formData?.company_policy_status==="Published"?  "policy-iframe-policy" : "policy-iframe-policy72" : formData?.company_policy_status==="Published"?  "policy-iframe-policy-text" : "policy-iframe-policy72-text"} `}
                                                                    style={{ width: "100%",border: "1px solid #ccc",}}>
                                                                    {formData?.company_policy_content_type === "1" ?
                                                                        checkPDFLink(formData?.company_policy_document_url) ?
                                                                        <iframe
                                                                            src={formData?.company_policy_document_url}
                                                                            title="PDF Viewer"
                                                                            style={{ width: "100%", height: "100%" }}
                                                                            frameBorder="0"
                                                                        >
                                                                            This browser does not support embedded files.
                                                                        </iframe> :
                                                                        <FileNotFound/> :
                                                                        <div className=' p-3 overflow-y-scroll' style={{ width: "100%", height: "100%" }}
                                                                        dangerouslySetInnerHTML={{ __html: formData?.company_policy_content }}/>
                                                                    }
                                                                </div>
                                                                {formData?.company_policy_status==="Published" &&  
                                                                ((formData?.company_policy_content_type === "1" && checkPDFLink(formData?.company_policy_document_url)) || 
                                                                formData?.company_policy_content ) && (
                                                                    <div className=' d-flex align-items-center gap-2 mt-2'>
                                                                        <input type="checkbox"
                                                                            id='checkedPolicy'
                                                                            name='checkedPolicy'
                                                                            className=' cursorPointer'
                                                                            checked={formData?.checkedPolicy}
                                                                            onChange={(e) => setFormData({ ...formData, checkedPolicy: e.target.checked })}
                                                                        />
                                                                        <label htmlFor='checkedPolicy' className='mb-0'>I agree to the Terms & Conditions.</label>
                                                                    </div>)
                                                                }
                                                            </div>
                                                        {/* </div> */}
                                                </div>
                                            </div>
                                            {formData?.company_policy_status==="Published" && (
                                                <div className="modal-footer pt-0">
                                                <button type="button" className="btn btn-light" disabled={postLoading}
                                                onClick={()=>{
                                                    if(!postLoading){
                                                        setPolicyModal(false);
                                                        handleClearAll();
                                                    }
                                                }}
                                                > Close</button>
                                                <SubmitButton
                                                onClick={()=>{
                                                    if(!postLoading && formData?.checkedPolicy){
                                                        handleSubmit();
                                                    }
                                                }}
                                                disabled={!formData?.checkedPolicy}
                                                loading={postLoading}
                                                loadingMessage='loading' buttonName={"Accept"} icon={'ri-save-line'} 
                                                type='success' iconSide='left' />
                                            </div>)
                                            }
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div > :
                <div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>

            }
        </>
    );
}

export default MyPolicy;